/* eslint-disable @typescript-eslint/no-explicit-any */
export function isEmpty(element: any) {
  if (
    element === '' ||
    element === undefined ||
    element === null ||
    element === 'undefined' ||
    !/[^\s]/.test(element) ||
    /^\s*$/.test(element)
  ) {
    return true;
  }

  return false;
}
